import React from 'react';

import { useTheme } from '@mui/material/styles';

import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';

const ApplyActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();
  return (
    <BaseActionButton
      styles={{
        color: theme.palette.success.main,
        '&:disabled': {
          color: theme.palette.grey[400],
        },
      }}
      {...props}>
      <DoneOutlinedIcon />
    </BaseActionButton>
  );
};

export default ApplyActionButton;
